
{{#TEMPLATE ctx 'name'}}
	<i class="fa fa-bell{{#if model.active}} success{{else}}-slash error{{/if}}"></i>
	<a data-idx="{{model.id}}" href="#" class="js-name">
	{{model.name}}
	</a>
{{/TEMPLATE}}

{{#TEMPLATE ctx 'stats'}}
	<strong>{{TR "Anfragen"}}</strong>&nbsp;{{total}}<br>
	<small>({{TR "Heute"}}&nbsp;{{daily}}&nbsp;{{TR "Monat"}}&nbsp;{{monthly}})</small>
{{/TEMPLATE}}
